/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ContractorPacketLine } from './ContractorPacketLine';
import {
    ContractorPacketLineFromJSON,
    ContractorPacketLineFromJSONTyped,
    ContractorPacketLineToJSON,
    ContractorPacketLineToJSONTyped,
} from './ContractorPacketLine';

/**
 * 
 * @export
 * @interface SendContractorPacketInviteBody
 */
export interface SendContractorPacketInviteBody {
    /**
     * 
     * @type {string}
     * @memberof SendContractorPacketInviteBody
     */
    toEmail: string;
    /**
     * 
     * @type {string}
     * @memberof SendContractorPacketInviteBody
     */
    origin: string;
    /**
     * 
     * @type {string}
     * @memberof SendContractorPacketInviteBody
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof SendContractorPacketInviteBody
     */
    contractorName: string;
    /**
     * 
     * @type {string}
     * @memberof SendContractorPacketInviteBody
     */
    role: string;
    /**
     * 
     * @type {string}
     * @memberof SendContractorPacketInviteBody
     */
    organizationName: string;
    /**
     * 
     * @type {string}
     * @memberof SendContractorPacketInviteBody
     */
    returnEmail: string;
    /**
     * 
     * @type {string}
     * @memberof SendContractorPacketInviteBody
     */
    invoiceNumber: string;
    /**
     * 
     * @type {string}
     * @memberof SendContractorPacketInviteBody
     */
    invoiceDate: string;
    /**
     * 
     * @type {Array<ContractorPacketLine>}
     * @memberof SendContractorPacketInviteBody
     */
    items: Array<ContractorPacketLine> | null;
}

/**
 * Check if a given object implements the SendContractorPacketInviteBody interface.
 */
export function instanceOfSendContractorPacketInviteBody(value: object): value is SendContractorPacketInviteBody {
    if (!('toEmail' in value) || value['toEmail'] === undefined) return false;
    if (!('origin' in value) || value['origin'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('contractorName' in value) || value['contractorName'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('organizationName' in value) || value['organizationName'] === undefined) return false;
    if (!('returnEmail' in value) || value['returnEmail'] === undefined) return false;
    if (!('invoiceNumber' in value) || value['invoiceNumber'] === undefined) return false;
    if (!('invoiceDate' in value) || value['invoiceDate'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function SendContractorPacketInviteBodyFromJSON(json: any): SendContractorPacketInviteBody {
    return SendContractorPacketInviteBodyFromJSONTyped(json, false);
}

export function SendContractorPacketInviteBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendContractorPacketInviteBody {
    if (json == null) {
        return json;
    }
    return {
        
        'toEmail': json['toEmail'],
        'origin': json['origin'],
        'type': json['type'],
        'contractorName': json['contractorName'],
        'role': json['role'],
        'organizationName': json['organizationName'],
        'returnEmail': json['returnEmail'],
        'invoiceNumber': json['invoiceNumber'],
        'invoiceDate': json['invoiceDate'],
        'items': (json['items'] == null ? null : (json['items'] as Array<any>).map(ContractorPacketLineFromJSON)),
    };
}

export function SendContractorPacketInviteBodyToJSON(json: any): SendContractorPacketInviteBody {
    return SendContractorPacketInviteBodyToJSONTyped(json, false);
}

export function SendContractorPacketInviteBodyToJSONTyped(value?: SendContractorPacketInviteBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'toEmail': value['toEmail'],
        'origin': value['origin'],
        'type': value['type'],
        'contractorName': value['contractorName'],
        'role': value['role'],
        'organizationName': value['organizationName'],
        'returnEmail': value['returnEmail'],
        'invoiceNumber': value['invoiceNumber'],
        'invoiceDate': value['invoiceDate'],
        'items': (value['items'] == null ? null : (value['items'] as Array<any>).map(ContractorPacketLineToJSON)),
    };
}

